import React, { useState } from "react";
import { Form, Button, Card } from "react-bootstrap";
import { toast } from "react-toastify";
import businessService from "../../services/businessService";

export default function AddBusiness(props) {
  const [name, setName] = useState("");
  const [link, setLink] = useState("");
  const [loading, setLoading] = useState(false);

  const addBusiness = (e) => {
    e.preventDefault();
    if (!name || !link) {
      toast.error("Fill out both fields");
      return;
    }
    setLoading(true);
    businessService
      .addBusiness(name, link, props.jwt)
      .then((response) => {
        setLoading(false);
        toast.success("Business created");
        props.fetchUser();
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err.response.data.msg || "Error occurred");
      });
  };
  return (
    <Card style={{ backgroundColor: "#d3d3d3", height: 300, padding: 6 }}>
      <h4>Add your business</h4>
      <Form>
        <div className="mb-3">
          <Form.Label>Business name</Form.Label>
          <Form.Control
            onChange={(e) => setName(e.target.value)}
            id="name"
            type="text"
            placeholder="Business name"
          />
        </div>
        <div className="mb-3">
          <Form.Label>Business website</Form.Label>
          <Form.Control
            onChange={(e) => setLink(e.target.value)}
            id="link"
            type="text"
            placeholder="mywebsite.com"
          />
        </div>
        {!loading ? (
          <Button
            onClick={addBusiness}
            variant="primary"
            type="submit"
            className="col-lg-4"
          >
            Add
          </Button>
        ) : (
          <p>Loading...</p>
        )}
      </Form>
    </Card>
  );
}
